import { Menu, Button } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../images/LOGO TROCAENVIO.png";
import { useAuth } from "../features/auth/AuthContext";

const items = [
  { key: "motoristas", label: "Motoristas", path: "/motoristas" },
  { key: "reservas", label: "Reservas", path: "/reservas" },
  { key: "roteirizador", label: "Roteirizador", path: "/roteirizador" },
  { key: "pedidos", label: "Pedidos", path: "/pedidos" },
  { key: "instalacoes", label: "Instalações", path: "/instalacoes" },
];

export function Sidebar({ isMobile = false, onNavigate }) {
  const location = useLocation();
  const { logout } = useAuth();

  const activeKey = items.find((item) => location.pathname.startsWith(item.path))?.key;

  const menuItems = items.map((item) => ({
    key: item.key,
    label: (
      <NavLink to={item.path} onClick={onNavigate}>
        {item.label}
      </NavLink>
    ),
  }));

  return (
    <div className="brand-sidebar">
      {!isMobile ? (
        <div className="brand-sidebar__top">
          <img src={logo} alt="Logo TrocaEnvio" className="brand-sidebar__logo" />
        </div>
      ) : null}

      <Menu mode="inline" selectedKeys={activeKey ? [activeKey] : []} items={menuItems} />

      <div className="brand-sidebar__logout">
        <Button
          type="text"
          onClick={logout}
          style={{ color: "var(--te-primary)", fontWeight: 700 }}
        >
          Sair
        </Button>
        <div style={{ marginTop: 12, fontSize: 12, opacity: 0.7, lineHeight: 1.5 }}>
          <a href="/legal/privacy.html" target="_blank" rel="noreferrer" style={{ color: "inherit" }}>
            Privacidade
          </a>
          {" • "}
          <a href="/legal/terms.html" target="_blank" rel="noreferrer" style={{ color: "inherit" }}>
            Termos
          </a>
        </div>
      </div>
    </div>
  );
}
